import { Loader2 } from 'lucide-react';

export function Button({
  children, onClick, type = 'button',
  variant = 'primary', size = '', full = false,
  disabled = false, loading = false, icon = null,
}) {
  const classes = [
    'btn',
    `btn-${variant}`,
    size ? `btn-${size}` : '',
    full ? 'btn-full' : '',
  ].filter(Boolean).join(' ');

  return (
    <button
      type={type}
      className={classes}
      onClick={onClick}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      aria-disabled={(disabled || loading) || undefined}
    >
      {loading ? (
        <>
          <Loader2 size={14} className="btn-spinner" aria-hidden="true" />
          <span>{children}</span>
        </>
      ) : (
        <>
          {icon && <span className="btn-icon" aria-hidden="true">{icon}</span>}
          {children}
        </>
      )}
    </button>
  );
}
